{% block sw_category_detail_topfeed %}
    <div class="sw-category-detail-topfeed">
        {% block sw_category_detail_topfeed_config %}

            <mt-card
                :title="$t('TopdataTopfeedSW6.settingsCardTitle')"
                :isLoading="isLoading"
            >

                <mt-switch
                        v-if="feedSettings"
                        :label="$t('TopdataTopfeedSW6.pluginSettings')"
                        v-model="feedSettings.pluginSettings"
                ></mt-switch>

                <div v-if="feedSettings && !feedSettings.pluginSettings">

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.name')"
                            v-model="feedSettings.importSettings.name"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.description')"
                            v-model="feedSettings.importSettings.description"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.brand')"
                            v-model="feedSettings.importSettings.brand"
                    ></mt-switch>


                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.EANs')"
                            v-model="feedSettings.importSettings.EANs"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.MPNs')"
                            v-model="feedSettings.importSettings.MPNs"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.pictures')"
                            v-model="feedSettings.importSettings.pictures"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.pictures"
                            :label="$t('TopdataTopfeedSW6.import.unlinkOldPictures')"
                            v-model="feedSettings.importSettings.unlinkOldPictures"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.properties')"
                            v-model="feedSettings.importSettings.properties"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.PCDsProp')"
                            v-model="feedSettings.importSettings.PCDsProp"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.MPNsProp')"
                            v-model="feedSettings.importSettings.MPNsProp"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importSimilar')"
                            v-model="feedSettings.importSettings.importSimilar"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importAlternates')"
                            v-model="feedSettings.importSettings.importAlternates"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importAccessories')"
                            v-model="feedSettings.importSettings.importAccessories"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importBoundles')"
                            v-model="feedSettings.importSettings.importBoundles"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importVariants')"
                            v-model="feedSettings.importSettings.importVariants"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importColorVariants')"
                            v-model="feedSettings.importSettings.importColorVariants"
                    ></mt-switch>

                    <mt-switch
                            :label="$t('TopdataTopfeedSW6.import.importCapacityVariants')"
                            v-model="feedSettings.importSettings.importCapacityVariants"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importSimilar"
                            :label="$t('TopdataTopfeedSW6.import.crossSimilar')"
                            v-model="feedSettings.importSettings.crossSimilar"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importAlternates"
                            :label="$t('TopdataTopfeedSW6.import.crossAlternates')"
                            v-model="feedSettings.importSettings.crossAlternates"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importAccessories"
                            :label="$t('TopdataTopfeedSW6.import.crossAccessories')"
                            v-model="feedSettings.importSettings.crossAccessories"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importBoundles"
                            :label="$t('TopdataTopfeedSW6.import.crossBoundles')"
                            v-model="feedSettings.importSettings.crossBoundles"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importVariants"
                            :label="$t('TopdataTopfeedSW6.import.crossVariants')"
                            v-model="feedSettings.importSettings.crossVariants"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importColorVariants"
                            :label="$t('TopdataTopfeedSW6.import.crossColorVariants')"
                            v-model="feedSettings.importSettings.crossColorVariants"
                    ></mt-switch>

                    <mt-switch
                            v-if="feedSettings.importSettings.importCapacityVariants"
                            :label="$t('TopdataTopfeedSW6.import.crossCapacityVariants')"
                            v-model="feedSettings.importSettings.crossCapacityVariants"
                    ></mt-switch>
                </div>
            </mt-card>
        {% endblock %}
    </div>
{% endblock %}